import { PageNavParams } from "@web-src/modules/navigation/types";
import { ModulePagesConfig } from "@web-src/modules/navigation/types/ModulePagesConfigs";
import { lazy } from "react";

const CreateBoardInTrial = lazy(() => import("./CreateBoardInTrial"));

export type TrialPagesNavigationParams = {
  createBoardInTrial: PageNavParams;
};

export const trialPagesNavigationConfig: ModulePagesConfig<TrialPagesNavigationParams> =
  {
    createBoardInTrial: {
      element: <CreateBoardInTrial />,
      path: "trial/create-board",
      isPrivate: false,
    },
  };
